import ThumbnailComponent from '72cms-ui/components/table-elements/ThumbnailComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {

        image: {
            component: ThumbnailComponent,
            variant: 'w50',
        },
        name: {
            label: 'Name',
        },
        title: {

        },
    },
    sortable: ['name'],
    filterable: [
        // 'customer_type'
    ],
    toolbar: [
        'create',
    ],
    customFilters: [],
    pagination: true,
    searchable: true,
    treeView: false,
    batchActions: [
        'delete', 'active',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.services.js